import {
    SET_ACCESS_TOKEN,
    USER_INFO_LOADED
} from 'src/actions/authActions';

const initialState = {
    user: null,
    isLoadingUser: false,
    accessToken: null,
    claims: null,

    userInfo: {
        displayName: '',
        companyName: '',
        streetAddress: '',
        city: '',
        postalCode: '',
        country: '',
        mail: '',
        surname: '',
        givenName: ''
    }
};

export const userInfoFields = Object.keys(initialState.userInfo);

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ACCESS_TOKEN: {
            return {
                ...state,
                accessToken: action.data
            };
        }
        case USER_INFO_LOADED: {
            return {
                ...state,
                userInfo: Object.keys(action.data).reduce((userInfoFields, field) => ({
                    ...userInfoFields,
                    [field]: action.data[field] && action.data[field] !== '' ? action.data[field] : userInfoFields[field]
                }), state.userInfo) ?? state.userInfo
            };
        }
        default:
            return state;
    }
};

export default reducer;